import React from 'react';
import { FeatureFlags, useFeatures } from '../contexts/FeatureContext';

const featureDescriptions: Partial<Record<keyof FeatureFlags, { title: string; message: string }>> = {
    orderBoardEnabled: {
        title: 'Board ordini non attivo',
        message: 'Contatta l’amministratore per abilitare la gestione ordini per questo tenant.',
    },
    cashflowEnabled: {
        title: 'Modulo cassa disattivato',
        message: 'Richiedi l’attivazione della cassa POS dal pannello amministratore per utilizzare questa sezione.',
    },
    printCenterEnabled: {
        title: 'Centro stampa disabilitato',
        message: 'Abilita il Centro stampa nelle funzionalità del tenant per accedere a questa pagina.',
    },
    posEnabled: {
        title: 'POS touch non disponibile',
        message: 'Attiva il modulo POS touch per utilizzare questa schermata operativa.',
    },
    tableServiceEnabled: {
        title: 'Gestione tavoli non abilitata',
        message: 'Abilita la gestione tavoli per visualizzare questa pagina.',
    },
};

type FeatureGateProps = {
    feature: keyof FeatureFlags;
    children: React.ReactNode;
};

export const FeatureGate: React.FC<FeatureGateProps> = ({ feature, children }) => {
    const { features, loading, error } = useFeatures();

    if (loading) {
        return <div className="feature-gate feature-gate__loading">Caricamento permessi…</div>;
    }

    if (error) {
        return (
            <div className="feature-gate feature-gate__error">
                <h2>Impossibile verificare le funzionalità</h2>
                <p>{error}</p>
            </div>
        );
    }

    if (!features[feature]) {
        const copy = featureDescriptions[feature];
        return (
            <div className="feature-gate feature-gate__disabled">
                <h2>{copy?.title ?? 'Funzionalità non disponibile'}</h2>
                <p>{copy?.message ?? 'Questa sezione non è disponibile per il tuo account. Contatta il supporto per maggiori informazioni.'}</p>
            </div>
        );
    }

    return <>{children}</>;
};

export const useFeatureEnabled = (feature: keyof FeatureFlags) => {
    const { features } = useFeatures();
    return Boolean(features[feature]);
};
